import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import Header from "@/components/Header";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1 flex items-center justify-center px-6 text-center">
        <div>
          <div className="font-mono text-[#C6F84C] text-6xl font-black">404</div>
          <h1 className="mt-4 text-3xl font-bold">Page not found.</h1>
          <p className="mt-3 text-zinc-400">The link you followed doesn't exist here.</p>
          <Link to="/" className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#C6F84C] text-black font-bold px-6 py-3">
            <ArrowLeft className="w-4 h-4" /> Back home
          </Link>
        </div>
      </div>
    </div>
  );
}
